import { AError } from "../../../../requests/types";
import { REQUEST_LOGOUT, LOGOUT_SUCCESS, LOGOUT_ERROR } from "../../actions";

// ----- REQUEST ----------------------------------------------------------
type RequestLogout = {
  type: typeof REQUEST_LOGOUT;
};

export const requestLogout = (): RequestLogout => ({
  type: REQUEST_LOGOUT,
});

// ----- SUCCESS ---------------------------------------------------------
type SuccessLogout = {
  type: typeof LOGOUT_SUCCESS;
};

export const successLogout = (): SuccessLogout => ({
  type: LOGOUT_SUCCESS,
});

// ----- ERROR -----------------------------------------------------------
type ErrorLogout = {
  type: typeof LOGOUT_ERROR;
  error: { error: AError };
};

export const errorLogout = (error: AError): ErrorLogout => ({
  type: LOGOUT_ERROR,
  error: { error },
});

export type LogoutActions = RequestLogout | SuccessLogout | ErrorLogout;
